import React, { FC, useEffect, useState } from "react";
import Header from "components/header/index";
import Footer from "components/footer/Footer";
import distanceIcon from "assets/svg/distance.svg";
import userIcon from "assets/svg/topic-user.svg";
import superHostKey from "assets/svg/superhost-user-key-indicator-for-avatar.svg";
import Styles from "views/profile/publicProfile/PublicProfile.module.scss";
import CardItem from "views/profile/publicProfile/card/item";
import ProfileAvatar from "components/profileAvatar/ProfileAvatar";
import { hasActiveOpenedRoom } from "helpers/utils";
import Button from "components/button/Button";
import Loader from "components/loader/loader";
import SEOMeta from "components/common/SEOMeta";

interface PublicProfileProps {
  profile: any;
  test: string;
  getPublicProfile: Function;
  followProfile: Function;
  loader?: boolean;
}

const PublicProfile: FC<PublicProfileProps> = (props: PublicProfileProps) => {
  const { profile, getPublicProfile, followProfile, loader } = props;
  const [publicProfile, setPublicProfile] = useState<any>();
  const [showToolTip, setShowToolTip] = useState(false);
  const [followToggle, setFollowToggle] = useState(false);
  const [isInitialLoading, setIsInitialLoading] = useState(true);
  const formatLoggedHours = (minutes: any) =>
    `${((minutes || 0) / 60).toFixed(2)}hrs`;

  const profileCardDetails = [
    {
      title: "Number of Rooms Started",
      description: "",
      total: publicProfile ? publicProfile.rooms_started : "",
    },
    {
      title: "Number of Hours Logged",
      description: "",
      total: publicProfile ? formatLoggedHours(publicProfile.logged_hours) : "",
      breakdown: publicProfile
        ? [
            {
              label: "Chat",
              value: formatLoggedHours(publicProfile.logged_hours_chat),
            },
            {
              label: "Video",
              value: formatLoggedHours(publicProfile.logged_hours_video),
            },
          ]
        : undefined,
    },
    {
      title: "Evictions",
      description: "Number of times they have been\nkicked out of a room",
      total: publicProfile ? publicProfile.number_of_eviction : "",
    },
  ];
  const user = JSON.parse(localStorage.getItem("user") || "{}");
  const { pk } = user;

  const handleFollow = () => {
    setFollowToggle(!followToggle);
    followProfile({ pk });
    console.log("Call");
  };

  useEffect(() => {
    getPublicProfile({ pk });
  }, [pk, getPublicProfile]);

  useEffect(() => {
    if (profile && Object.keys(profile).length > 0) {
      setPublicProfile(profile);
      setIsInitialLoading(false);
    }
  }, [profile]);

  useEffect(() => {
    if (!loader && profile && Object.keys(profile).length > 0) {
      setIsInitialLoading(false);
    }
  }, [loader, profile]);

  useEffect(() => {}, [followToggle]);

  const isLoading =
    isInitialLoading ||
    loader ||
    !publicProfile ||
    Object.keys(publicProfile || {}).length === 0;

  return (
    <div className={`${Styles.pageShell} appPageScroll`}>
      <SEOMeta
        title={user?.name || "User Profile"}
        description={
          user?.name
            ? `${user.name} on Moderate Politics.`
            : "View user public profile on Moderate Politics."
        }
        ogType="profile"
      />
      <Header />
      <section className={`custom-container ${Styles.pageContent}`}>
        {isLoading ? (
          <div className={Styles.loadingWrapper}>
            <div className={Styles.loadingContent}>
              <Loader aligned />
              <p className={Styles.loadingText}>Loading profile data...</p>
            </div>
          </div>
        ) : (
          <>
            <div className={Styles.profileSection}>
              <div className={Styles.profileBox}>
                <div className={Styles.profileBoxInner}>
                  <div className={Styles.profileImageWrapper}>
                    <ProfileAvatar
                      profile={user.profile}
                      loading="lazy"
                      className={Styles.profileImage}
                      alt="profile img"
                    />
                    {publicProfile?.profile?.is_super_host && (
                      <img
                        src={superHostKey}
                        loading="lazy"
                        alt="is super host"
                        className={Styles.superHostKey}
                      />
                    )}
                  </div>
                  <div className={Styles.profileMeta}>
                    <h3>{user.name}</h3>
                    <p>ID NUMBER: {user.pk}</p>
                  </div>
                </div>
                <div className="position-relative">
                  {/*<Button*/}
                  {/*  label={`${publicProfile && publicProfile.is_profile_follow ? 'Unfollow' : 'Follow'}`}*/}
                  {/*  cssClass={Styles.followBtn}*/}
                  {/*  clickHandler={handleFollow}*/}
                  {/*  // onMouseEnter={() => setShowToolTip(true)}*/}
                  {/*  // onMouseLeave={() => setShowToolTip(false)}*/}
                  {/*  showLoading={loader}*/}
                  {/*/>*/}
                  {/*<button*/}
                  {/*  type="button"*/}
                  {/*  className={Styles.followBtn}*/}
                  {/*  onClick={handleFollow}*/}
                  {/*  onKeyUp={handleFollow}*/}
                  {/*  onMouseEnter={() => setShowToolTip(true)}*/}
                  {/*  onMouseLeave={() => setShowToolTip(false)}*/}
                  {/*>*/}
                  {/*  {publicProfile && publicProfile.is_profile_follow ? 'Unfollow' : 'Follow'}*/}
                  {/*</button>*/}
                  {showToolTip && (
                    <div className={Styles.followToolTip}>
                      <p className={`mb-0 ${Styles.toolTip}`}>
                        Follow to receive notifications when this host starts a
                        room.
                      </p>
                    </div>
                  )}
                </div>
              </div>
              <div className={Styles.cardWrapper}>
                {profileCardDetails.map((item, key) => (
                  <CardItem
                    title={item.title}
                    description={item.description}
                    total={item.total}
                    breakdown={item.breakdown}
                    key={key}
                  />
                ))}
              </div>
            </div>
            <hr className={Styles.sectionDivider} />
            <div className={Styles.openCardWrapper}>
              {hasActiveOpenedRoom(publicProfile?.opened_room) && (
                <>
                  <h4>Latest Topic</h4>
                  <div className={Styles.openRoomCard}>
                    <div className={Styles.openCardInner}>
                      <div>
                        <div className="d-flex justify-content-start align-items-center">
                          <h5 className={Styles.topicLabel}>TOPIC:</h5>
                          <div className={Styles.topicBtn}>
                            {publicProfile.opened_room.topic}
                          </div>
                        </div>
                        <div
                          className={`d-flex justify-content-start align-items-center column-gap-20 mt-4 
                      ${Styles.distanceWrapper}`}
                        >
                          <div>
                            <img src={distanceIcon} alt="distance" />
                            <span>
                              {publicProfile.distance_in_km.toFixed(2)} KM
                            </span>
                          </div>
                          <div>
                            <img src={userIcon} alt="people" />
                            <span>
                              {publicProfile.total_participants} people are in this room
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              )}
            </div>
          </>
        )}
      </section>
      <div className={Styles.footerSlot}>
        <Footer />
      </div>
    </div>
  );
};
export default PublicProfile;
